import { createSlice } from "@reduxjs/toolkit";
import {
  AddMaliciousWords,
  DeleteMaliciousWords,
  GetAllMaliciousWords,
  UpdateMaliciousWords,
} from "store/middlewares/dataManagement/maliciousWords";
import { GetMaliciousReports } from "store/middlewares/maliciousReports";

// isDeleteMeFulFilled
export const maliciousWordSlice = createSlice({
  name: "maliciousWord",
  initialState: {
    maliciousWordLoading: true,
    maliciousWord: null,
    maliciousReports: null,
    maliciousReportsLoading: true,
  },
  reducers: {
    updateUserStatus: (state, action) => {
      const { id, status } = action.payload;

      state.maliciousReports?.data?.forEach((report) => {
        if (report.sender.id === id) {
          report.sender.status = status;
        }
      });
    },
  },
  extraReducers(builder) {
    builder

      // get malicious word
      .addCase(GetAllMaliciousWords.pending, (state) => {
        /*  state.maliciousWordLoading = true;
        state.maliciousWord = null; */
        state.maliciousWord =
          state.maliciousWord?.data?.length > 0 ? state.maliciousWord : null;
      })
      .addCase(GetAllMaliciousWords.fulfilled, (state, action) => {
        state.maliciousWordLoading = false;
        state.maliciousWord = action.payload.response;
      })
      .addCase(GetAllMaliciousWords.rejected, (state) => {
        state.maliciousWordLoading = false;
        state.maliciousWord = null;
      })

      // for update malicious word
      .addCase(UpdateMaliciousWords.pending, (state) => {
        state.maliciousWordLoading = true;
      })
      .addCase(UpdateMaliciousWords.fulfilled, (state, action) => {
        state.maliciousWordLoading = false;
        state.maliciousWord = {
          ...state.maliciousWord,
          data: state.maliciousWord.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      .addCase(UpdateMaliciousWords.rejected, (state) => {
        state.maliciousWordLoading = false;
      })
      // for deleting malicious word
      .addCase(DeleteMaliciousWords.pending, (state) => {
        state.maliciousWordLoading = true;
        state.maliciousWord =
          state.maliciousWord?.data?.length > 0 ? state.maliciousWord : null;
      })
      .addCase(DeleteMaliciousWords.fulfilled, (state, action) => {
        state.maliciousWordLoading = false;
        state.maliciousWord = action.payload.response;
      })
      .addCase(DeleteMaliciousWords.rejected, (state) => {
        state.maliciousWordLoading = false;
      })
      .addCase(AddMaliciousWords.fulfilled, (state, action) => {
        state.maliciousWordLoading = false;
        state.maliciousWord = action.payload.response;
      })
      .addCase(GetMaliciousReports.pending, (state) => {
        state.maliciousReportsLoading =
          state.maliciousReports?.data?.length > 0 ? false : true;
        state.maliciousReports =
          state.maliciousReports?.data?.length > 0
            ? state.maliciousReports
            : null;
      })
      .addCase(GetMaliciousReports.fulfilled, (state, action) => {
        state.maliciousReportsLoading = false;
        state.maliciousReports = action.payload.response;
      })

      .addCase(GetMaliciousReports.rejected, (state) => {
        state.maliciousReportsLoading = false;
        state.maliciousReports = null;
      });
  },
});
export const { updateUserStatus } = maliciousWordSlice.actions;

export default maliciousWordSlice.reducer;
